export default `#version 300 es

precision highp float;

uniform mat4 u_renderHomogeneousTransform;
uniform float u_animationProgress;

in vec2 a_resourceTrianglePoint;
in vec2 a_clipPreviousTrianglePoint;
in vec2 a_clipTrianglePoint;
in float a_previousTrianglePointDistortion;
in float a_trianglePointDistortion;
in float a_trianglePointIndex;
in float a_trianglePointInside;

out vec2 v_resourceTrianglePoint;
out float v_trianglePointDistortion;
out float v_trianglePointIndex;
out vec4 v_trianglePointBarycentric;
out float v_trianglePointInside;

void main() {
  
  vec2 clipTrianglePoint = mix(a_clipPreviousTrianglePoint, a_clipTrianglePoint, u_animationProgress);
  float trianglePointDistortion = mix(a_previousTrianglePointDistortion, a_trianglePointDistortion, u_animationProgress);

  
  
  

  gl_Position = u_renderHomogeneousTransform * vec4(clipTrianglePoint, 0.0f, 1.0f);

  
  v_resourceTrianglePoint = a_resourceTrianglePoint;
  v_trianglePointDistortion = trianglePointDistortion;
  v_trianglePointIndex = a_trianglePointIndex;
  v_trianglePointInside = a_trianglePointInside;

  float trianglePointLocalIndex = mod(a_trianglePointIndex, 3.0f);
  if(trianglePointLocalIndex == 0.0f)
    v_trianglePointBarycentric = vec4(1.0f, 0, 0, 1.0f);
  if(trianglePointLocalIndex == 1.0f)
    v_trianglePointBarycentric = vec4(0.0f, 1.0f, 0, 1.0f);
  if(trianglePointLocalIndex == 2.0f)
    v_trianglePointBarycentric = vec4(0.0f, 0, 1.0f, 1.0f);
}`